import { FontAwesome5 } from '@expo/vector-icons';
import { OEText } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React, { memo } from 'react';

export interface PCFeedbackRubricItemProps {
  children: string;
  onPress: () => void;
  isChecked?: boolean;
}

const PCFeedbackRubricItem = ({
  children,
  isChecked,
  onPress,
}: PCFeedbackRubricItemProps) => {
  return (
    <Container isChecked={isChecked} onPress={onPress}>
      <OEText fontType="bold" fontSize={16} numberOfLines={2}>
        {children}
      </OEText>
      <ChecboxkWrapper size={24} isChecked={isChecked}>
        <IconCheckbox />
      </ChecboxkWrapper>
    </Container>
  );
};

type CommonStyledType = {
  isChecked?: boolean;
};

const Container = styled.TouchableOpacity<CommonStyledType>`
  border-width: 1px;
  border-color: ${({ theme, isChecked }) =>
    isChecked ? theme.color.primary : theme.color.border};
  border-radius: 14px;
  padding: 16px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

type ChecboxkWrapperType = {
  size: number;
} & CommonStyledType;

const ChecboxkWrapper = styled.View<ChecboxkWrapperType>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${({ size }) => size / 2}px;
  background-color: ${({ theme, isChecked }) =>
    isChecked ? theme.color.primary : theme.color.light1};
  justify-content: center;
  align-items: center;
  margin-left: 8px;
`;

const IconCheckbox = styled(FontAwesome5).attrs(({ theme }) => {
  return {
    color: theme.color.white,
    size: 15,
    name: 'check',
  };
})``;

export default memo(PCFeedbackRubricItem);
